import { getGoalCollectionCategories } from '@/composables/utils'
import { getCategoryGoalCollectionRatingAvg } from '@/composables/ratings/getCategoryGoalCollectionRatingAvg'

export const getGoalCollectionDatasets = (collection) => {
  // Get framework categories
  // Get all goals from the collection
  // For each goal in the collection map the goal rating to the correct category
  // Sum the ratings for each category
  const categories = getGoalCollectionCategories(collection)
  const dataValues = categories.map(category => {
    return getCategoryGoalCollectionRatingAvg(category.id, collection.id)
  })
  return [
    {
      label: collection.title,
      values: dataValues,
      opacity: 1,
      frameworkId: collection.frameworkId,
    },
  ]
}
